<template>
  <BaseWarning>
    <i18n path="warnings.dutyCounts.warning" tag="span">
      <template #duty>{{ duty }}</template>
      <template #count>{{ data.count }}</template>
      <template #targetCount>{{ data.expected }}</template>
      <template #thisDuty>{{ thisDuty }}</template>
    </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from "./BaseWarning.vue";

export default {  
  props: {
    data: Object
  },

  components: { BaseWarning },

  computed: {
    duty() {
      if (this.data.duty === "defend") {
        return this.$t("warnings.responsibilities.join3Caveats", [
          this.$t("duties.defend").toLowerCase(),
          this.$t("duties.stopper").toLowerCase(),
          this.$t("duties.cover").toLowerCase(),
        ]);
      }
      return this.$t(`duties.${this.data.duty}`).toLowerCase();
    },

    thisDuty() {
      if (this.data.duty === "defend") {
        return this.$t("warnings.dutyCounts.theseDuties");
      }
      return this.$t("warnings.dutyCounts.thisDuty");
    }
  }
};
</script>
